import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmInboxIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmInboxIcon = ({ className, ...props }: EmInboxIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_518_35876)">
      <path
        d="M13.9992 14.4667H10.8522V21.3125H13.9992V14.4667Z"
        fill="#C87D5E"
      />
      <path
        d="M13.9992 16.1958C13.7173 15.7386 13.3444 15.3484 12.8734 15.0941C12.5812 14.9359 12.2581 14.8449 11.9298 14.8122H11.3815C11.2028 14.8294 11.024 14.8638 10.8522 14.9153V18.3752C11.0051 18.1414 11.2595 17.973 11.5345 17.9077C12.014 17.7959 12.5228 17.9799 12.9112 18.2806C13.2997 18.5814 13.5901 18.9905 13.8737 19.3909C13.9167 19.4511 13.958 19.5095 14.0009 19.5697V16.1958H13.9992Z"
        fill="#874D36"
      />
      <path
        d="M4.97402 4.97922C7.01246 4.97922 8.67105 6.35766 8.67105 8.05406V16.2353H1.27527V8.05406C1.27527 6.35766 2.93386 4.97922 4.97402 4.97922Z"
        fill="#4E342E"
      />
      <path
        d="M9.44794 16.1889H3.28794C2.92185 16.1889 2.61247 15.9191 2.56263 15.5564L1.69638 9.26062C1.65513 8.95984 1.88888 8.69171 2.1931 8.69171H9.44794V16.1889Z"
        fill="white"
      />
      <path
        d="M16.7663 4.31235H4.974C4.974 4.31235 9.02681 4.80907 9.02681 8.22766L9.04744 16.9039H20.4806C20.9395 16.9039 21.3107 16.5327 21.3107 16.0738V8.85844C21.3124 6.34735 19.2774 4.31235 16.7663 4.31235Z"
        fill="#1976D2"
      />
      <path
        d="M14.3464 5.84548L12.9474 5.89361L10.9106 9.01829C10.9106 9.01829 10.9106 7.36314 10.9106 6.48314C10.9106 5.12876 9.53564 4.31064 9.53564 4.31064H14.8913L14.9188 4.33814C15.4808 4.87267 15.1216 5.81798 14.3464 5.84548Z"
        fill="#0D47A1"
      />
      <path
        d="M12.7549 10.8659C13.5276 10.8659 14.154 10.1611 14.154 9.29157C14.154 8.42207 13.5276 7.71719 12.7549 7.71719C11.9822 7.71719 11.3558 8.42207 11.3558 9.29157C11.3558 10.1611 11.9822 10.8659 12.7549 10.8659Z"
        fill="#0D47A1"
      />
      <path
        d="M11.4967 1.73766L11.5019 8.88078C11.5019 9.12141 11.6961 9.31563 11.9367 9.31563H12.815C13.0556 9.31563 13.2498 9.12141 13.2498 8.88078V0.6875H12.5451C11.9659 0.6875 11.4967 1.15672 11.4967 1.73766Z"
        fill="#C62828"
      />
      <path
        d="M11.88 1.73766L11.8852 8.88078H13.2894V3.34984H15.7094C16.268 3.34984 16.3333 3.1075 16.3333 2.05219C16.3333 0.996875 16.2697 0.6875 15.7111 0.6875H12.9284C12.3492 0.6875 11.88 1.15672 11.88 1.73766Z"
        fill="#F44336"
      />
      <path
        d="M12.7858 1.87C12.7737 2.21203 12.5503 5.30922 12.5108 5.89016C12.4626 6.59313 12.057 6.66531 12.057 6.02594V1.83906C12.0587 1.16188 12.8115 1.12578 12.7858 1.87Z"
        fill="#FF7555"
      />
      <path
        d="M12.6156 7.29438L12.6277 10.4414C12.6277 10.4414 12.2925 10.4414 11.9161 10.4414C11.22 10.4414 10.6562 9.73673 10.6562 8.86704C10.6562 7.99735 11.22 7.29266 11.9161 7.29266C12.6122 7.29266 12.6156 7.29438 12.6156 7.29438Z"
        fill="#82AEC0"
      />
      <path
        d="M12.6157 10.4414C13.3115 10.4414 13.8755 9.73654 13.8755 8.86704C13.8755 7.99754 13.3115 7.29266 12.6157 7.29266C11.9199 7.29266 11.3558 7.99754 11.3558 8.86704C11.3558 9.73654 11.9199 10.4414 12.6157 10.4414Z"
        fill="#E0E0E0"
      />
      <path
        d="M11.8628 8.91343C11.9384 8.95124 12.0295 8.90999 12.0948 8.85499C12.2942 8.68827 12.3698 8.41327 12.5537 8.23108C12.7153 8.06952 12.9611 7.91139 12.7686 7.67249C12.6293 7.50061 12.3939 7.52983 12.21 7.6089C11.8026 7.77905 11.4795 8.72093 11.8628 8.91343Z"
        fill="white"
      />
      <path
        d="M4.97406 5.02391C6.99703 5.02391 8.64359 6.39203 8.64359 8.07469V16.1906H1.30453V8.07297C1.30453 6.39204 2.95109 5.02391 4.97406 5.02391ZM4.97406 4.31235C2.37359 4.31235 0.6875 6.06375 0.6875 8.22594V16.5361C0.6875 16.7372 0.850781 16.9022 1.05359 16.9022H9.31906C9.52016 16.9022 9.68516 16.7389 9.68516 16.5361V8.22594C9.68172 6.06375 7.57453 4.31235 4.97406 4.31235Z"
        fill="#4FC3F7"
      />
      <path
        d="M3.03877 15.7266C2.93736 15.6733 3.02158 15.5719 3.0783 15.4791L5.37627 11.4761L5.8283 11.7511L3.2708 15.5977C3.20549 15.6974 3.14018 15.7799 3.03877 15.7266Z"
        fill="#6FBFF0"
        stroke="#6FBFF0"
        strokeMiterlimit="10"
        strokeWidth="0.171875"
      />
      <path
        d="M6.85604 12.8786L2.08822 9.21766C2.02979 9.17813 1.97994 9.10595 2.0401 9.03376C2.08822 8.97532 2.13291 9.00626 2.21713 9.0561L6.83713 12.2392C6.954 12.3114 7.10526 12.2805 7.18604 12.1705L8.56447 10.3039L8.56104 11.1409L7.39916 12.7806C7.27197 12.9542 7.03307 12.9972 6.85604 12.8786Z"
        fill="#6FBFF0"
        stroke="#6FBFF0"
        strokeMiterlimit="10"
        strokeWidth="0.171875"
      />
    </g>
    <defs>
      <clipPath id="clip0_518_35876">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmInboxIcon;
